import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { AxiosResponse } from 'axios'

export interface Validity {
  amb_code?: string;
  available_credits: number;
  date_created: string;
  end_date: string;
  start_date: string;
  last_schedule?: {
    id: number;
    professional_name: string;
  };
  max_appointment: number;
  plan_password: string;
  reason_code?: string;
  status_code: string;
  status_name: string;
}

export interface ProfessionalMedicalRequestsResponse {
  pagination: {
    page: number;
    pages: number;
    per_page: number;
    total: number;
  };
  person_profile_plan_treatment_validities: Validity[]
}

interface ListProfessionalMedicalRequests {
  query?: string; 
  statusCode?: string; 
  page?: number; 
  perPage?: number;
  dateCreatedGTE?: string; 
  dateCreatedLTE?: string;
  sort?: string;
  startDateLTE?: string;
  startDateGTE?: string;
  endDateLTE?: string;
  endDateGTE?: string;
}

export async function listProfessionalMedicalRequests({
  query, 
  statusCode, 
  page, 
  perPage,
  dateCreatedGTE, 
  dateCreatedLTE,
  sort,
  startDateLTE,
  startDateGTE,
  endDateLTE,
  endDateGTE,
}: ListProfessionalMedicalRequests): Promise<ProfessionalMedicalRequestsResponse> {

  const params = {
    ...(query && { query }),
    ...(statusCode && { status_code: statusCode }),
    ...(page && { page }),
    ...(perPage && { per_pag: perPage }),
    ...(dateCreatedGTE && { date_created__gte: dateCreatedGTE }),
    ...(dateCreatedLTE && { date_created__lte: dateCreatedLTE }),
    ...(sort && { sort }),
    ...(startDateLTE && { start_date__lte: startDateLTE }),
    ...(startDateGTE && { start_date__gte: startDateGTE }),
    ...(endDateLTE && { end_date__lte: endDateLTE }),
    ...(endDateGTE && { end_date__gte: endDateGTE }),
  }

  const { data }: AxiosResponse<ProfessionalMedicalRequestsResponse> = await axios.get(
    apiEndpoints.VALIDITIES, { params })

  return data
}